import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LanguageManagementService } from '../../../service/language-management.service';
import { KeyValues3, Wrapper3, LocalService, Status, TriggeredEvent } from '../../../service/local.service';

@Component({
  selector: 'app-languages-content',
  templateUrl: './languages-content.component.html',
  styleUrls: ['./languages-content.component.scss']
})
export class LanguagesContentComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["section_config_popup"];
  wrapper: Wrapper3; maxBodyHeight = 0;
  id: string;
  languages: any;
  sectionId: string = '';
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.onLoad();
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onLoad() {
    if (this.id == '') {
      this.wrapper = {
        content: { v1: '', v2: this.sectionId } as KeyValues3,
      } as Wrapper3;
    }
    else {
      this.languageManagementService.getLanguagesConfigSection(this.id).subscribe(result => {
        this.wrapper = result;
      });
    }
  }

  onEmptyLanguageContainerAdded(languageContents: KeyValues3[]) {
    this.wrapper.languageContents = languageContents;
  }

  onPopupClose() {
    this.activeModal.close({ event: TriggeredEvent.Close });
  }

  onPopupSave() {
    this.languageManagementService.saveLanguageConfigSection(this.wrapper).subscribe(result => {
      if (result.status == Status.Success) {
        this.wrapper.content.key = this.id == '' ? result.id : this.id;
        this.activeModal.close({ event: TriggeredEvent.Ok, wrapper: this.wrapper });
      }
    });
  }
}
